import React, { useEffect, useRef, useState, useMemo, useCallback } from "react";
import "./JuryScoreBoard.scss";
import {
  Description,
  RedContent,
  RedMainHeading,
  StatusSubContent,
  SubGreyHeading,
} from "../../Global/GlobalText";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import {
  InputTextarea,
  InputType,
  SelectBgWhiteBorder,
} from "../../Global/GlobalFormElement";
import {
  GreyBackgroundButton,
  GreyBorderButton,
  RedBackgroundButton,
} from "../../Global/GlobalButton";
import { JuryTitleBar } from "../../Global/JuryTitleBar/JuryTitleBar";
import { useLocation, useNavigate } from "react-router-dom";
import { EXCHNAGE_URL, EXCHNAGE_URL_JUDGE } from "../../../Url/Url";
import axios from "axios";
import { toast } from "react-toastify";
import { evaluate } from "mathjs";
import { useLoading } from "../../LoadingContext";

export const JuryUpdateScoreBoard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [judgingData, setJudgingData] = useState([]);
  const [judgingFieldData, setJudgingFieldData] = useState([]);
  const [normalJudgeData, setNormalJudgeData] = useState({});
  const [selectedScores, setSelectedScores] = useState({});
  const [comments, setComments] = useState("");
  const token = localStorage.getItem("juryToken");
  const searchParams = new URLSearchParams(location.search);
  const { setLoading } = useLoading();
  const hasFetchedData = useRef(false);
  const [formSchema, setFormSchema] = useState([]);
  const [entryFormId, setEntryFormId] = useState("");
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);

  const {
    logoImg,
    eventName,
    fName,
    lName,
    awardCat,
    juryData,
    selectedAwardId,
    queryParams,
    eventIdd,
    submission_id,
    judgeId,
    awardCatId,
  } = location.state || {};

  // Required parameters
  const judgemail = searchParams.get("judgemail");
  const eventId = searchParams.get("eventId");
  const roundId = searchParams.get("roundId");

  useEffect(() => {
    if (!judgemail || !eventId || !roundId) {
      navigate("/404");
    }
  }, [judgemail, eventId, roundId, navigate]);

  const fetchDataToScore = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${EXCHNAGE_URL_JUDGE}/fetchDataToScore`,
        {
          params: {
            eventId: eventIdd,
            awardId: selectedAwardId,
            submission_id: submission_id,
            roundId: roundId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {

        const { submissionData, scorecards } = response.data.data;
        setEntryFormId(submissionData.entry_form_id);
        await handleEntryForm(submissionData.entry_form_id);
        setNormalJudgeData(submissionData);
        setJudgingData(scorecards);
        setJudgingFieldData(submissionData.fields);
        console.log("FIELDS", submissionData.fields);
        console.log("MEDIA", submissionData.media_files);
        const dataNames = scorecards.flatMap((entry) =>
          JSON.parse(entry.form_schema).flatMap((schema) =>
            schema.fields.map((field) => field.dataName)
          )
        );

        const scoreResponse = await axios.post(
          `${EXCHNAGE_URL_JUDGE}/scorecardgetsubmission`,
          { dataNames },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (scoreResponse.status === 200 && scoreResponse.data.DATA.length > 0) {
          toast.success("Scores Fetched Successfully");

          const scores = scoreResponse.data.DATA.reduce((acc, curr) => {
            scorecards.forEach((entry) => {
              JSON.parse(entry.form_schema).forEach((schema) => {
                schema.fields.forEach((field) => {
                  if (field.dataName === curr.dataName) {
                    acc[`${entry.scoreFormId}-${curr.dataName}`] = curr.score;
                  }
                });
              });
            });
            return acc;
          }, {});

          setSelectedScores(scores);
        } else {
          toast.info("No Scores Found");
        }
      } else {
        toast.info("No Submission Data Found");
      }
    } catch (error) {
      toast.error(`Error fetching data: ${error.message}`);
      console.error("Error:", error);
      navigate(`/jury-dashboard?${new URLSearchParams(queryParams)}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (eventIdd && selectedAwardId && submission_id && roundId && !hasFetchedData.current) {
      fetchDataToScore();
      hasFetchedData.current = true;
    }
  }, [eventIdd, selectedAwardId, submission_id, roundId]);

  const handleScoreChange = (scoreFormId, dataName, value) => {
    setSelectedScores(prev => ({
      ...prev,
      [`${scoreFormId}-${dataName}`]: Number(value)
    }));
  };

  const parseFormula = (scorecard, scores) => {
    try {
      const formula = scorecard.overall_score;
      const titleFields = JSON.parse(scorecard.form_schema)
        .flatMap(schema => schema.fields)
        .filter(field => field.label === "Title");

      let expression = formula;
      const matches = formula.matchAll(/{(\d+)}/g);

      for (const match of matches) {
        const index = parseInt(match[1]) - 1;
        if (index >= 0 && index < titleFields.length) {
          const dataName = titleFields[index].dataName;
          const scoreKey = `${scorecard.scoreFormId}-${dataName}`;
          const value = scores[scoreKey] || 0;
          expression = expression.replace(match[0], value);
        }
      }

      return evaluate(expression);
    } catch (error) {
      console.error("Error parsing formula:", error);
      return 0;
    }
  };
  const calculateTotalScore = () => {
    const totalScore = judgingData.reduce((total, scorecard) => {
      return total + parseFormula(scorecard, selectedScores);
    }, 0);
    return Math.round(totalScore);

  };

  const calculateMaxScore = () => {
    const totalMaxScore = judgingData.reduce((total, scorecard) => {
      const formula = scorecard.overall_score;
      const titleFields = JSON.parse(scorecard.form_schema)
        .flatMap(schema => schema.fields)
        .filter(field => field.label === "Title");

      // Replace all placeholders with max values
      let maxExpression = formula;
      const matches = formula.matchAll(/{(\d+)}/g);

      for (const match of matches) {
        const index = parseInt(match[1], 10) - 1;
        if (index >= 0 && index < titleFields.length) {
          const maxValue = titleFields[index].maxValue || 10;
          maxExpression = maxExpression.replace(match[0], maxValue);
        }
      }

      try {
        return total + evaluate(maxExpression);
      } catch (error) {
        console.error("Error calculating max score:", error);
        return total;
      }
    }, 0);

    return Math.round(totalMaxScore);
  };
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const payload = {
        eventId: eventIdd,
        awardId: selectedAwardId,
        roundId: roundId,
        judgeId: judgeId,
        submission_id: submission_id,
        abstain: normalJudgeData?.is_abstain || 0,
        comment: comments || "",
        total: calculateTotalScore(),
        is_pending: 0,
        is_completed: 1,
        is_confirmed: 1,
        criteria: judgingData.flatMap(entry => {
          const formSchema = JSON.parse(entry.form_schema);

          const titleFields = formSchema.flatMap(schema =>
            schema.fields.filter(field => field.label === "Title")
          );

          return titleFields.map(titleField => {
            const scoreKey = `${entry.scoreFormId}-${titleField.dataName}`;
            return {
              score: selectedScores[scoreKey] || 0,
              score_title: titleField?.value || "Unknown",
              dataName: titleField.dataName || "UnkownDataName",
              is_pending: 0,
              is_completed: 1,
              is_confirmed: 1
            };
          });
        })
      };

      const response = await axios.post(
        `${EXCHNAGE_URL_JUDGE}/submitScore`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200) {
        toast.success("Scores Updated successfully!");
        navigate(`/jury-entry-listing?${new URLSearchParams(queryParams).toString()}`, {
          state: {
            logoImg,
            eventName,
            fName,
            lName,
            awardCat,
            eventId,
            juryData,
            queryParams,
            eventIdd,
            awardCatId,
          }
        })
      }
      else {
        toast.error("Failed to Update scores");

      }
    } catch (error) {
      toast.error(`Submission failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
const handleViewMedia = async (media) => {
  try {
    setLoading(true);
    const res = await axios.get(
      `https://api.awardsuite.in/api/media/${media.id}`,
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem("juryToken")}`,
        },
      }
    );

    // Open all files in new tab
    window.open(res.data.url, "_blank");
  } catch (error) {
    toast.error("Failed to load media");
    console.error(error);
  } finally {
    setLoading(false);
  }
};


  const handleEntryForm = async (formId) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/entryForm?eventId=${eventIdd}&entryFormId=${formId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("juryToken")}`,
          },
        }
      );
      if (response.status === 200) {
        const fetchedFields = response.data.data.form_schema;
        console.log("FETCHED FIELDS", fetchedFields); 
        const jsonArray = JSON.parse(fetchedFields);
        setFormSchema(jsonArray);
      } else {
        toast.error("Failed to fetch the Entry form.");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const fieldValueMap = useMemo(() => {
    const map = {};
    judgingFieldData.forEach((field) => {
      const key = Object.keys(field).find((k) => k !== "entryDataId");
      if (key) {
        map[key] = field[key];
      }
    });
    return map;
  }, [judgingFieldData]);

  const isFieldVisible = useCallback(
    (field) => {
      const {
        visibleInJudgingCondition,
        visibleInJudgingFieldValue,
        visibleInJudgingInConditionValue,
        isVisibleCheckedInJudging,
      } = field;

      // HARD STOP: if "Visible In Judging" is unchecked, hide field
      if (isVisibleCheckedInJudging === false) {
        return false;
      }

      if (
        !visibleInJudgingCondition ||
        !visibleInJudgingFieldValue ||
        !visibleInJudgingInConditionValue
      ) {
        return true;
      }

      const conditions = Array.isArray(visibleInJudgingCondition)
        ? visibleInJudgingCondition
        : [visibleInJudgingCondition];
      const fieldValues = Array.isArray(visibleInJudgingFieldValue)
        ? visibleInJudgingFieldValue
        : [visibleInJudgingFieldValue];
      const conditionValues = Array.isArray(visibleInJudgingInConditionValue)
        ? visibleInJudgingInConditionValue
        : [visibleInJudgingInConditionValue];

      for (let i = 0; i < fieldValues.length; i++) {
        const currentField = fieldValues[i];
        const currentCondition = conditions[i] || conditions[0];
        const expectedValue = conditionValues[i] || conditionValues[0];
        const actualValue = fieldValueMap[currentField];
        console.log("================================");
        console.log("FIELD LABEL:", field.label);
        console.log("currentField:", currentField);
        console.log("actualValue:", actualValue);
        console.log("expectedValue:", expectedValue);
        console.log("condition:", currentCondition);
        console.log("fieldValueMap:", fieldValueMap);
        console.log("================================");
        if (actualValue === undefined) return false;

        let conditionMet;
        switch (currentCondition) {
          case "Equals":
            conditionMet =
              String(actualValue).trim().toLowerCase() ===
              String(expectedValue).trim().toLowerCase();
            break;
          case "contains":
            conditionMet = actualValue.includes(expectedValue);
            break;
          case "startsWith":
            conditionMet = actualValue.startsWith(expectedValue);
            break;
          case "endsWith":
            conditionMet = actualValue.endsWith(expectedValue);
            break;
          case "not-contains":
            conditionMet = !actualValue.includes(expectedValue);
            break;
          case "not-startsWith":
            conditionMet = !actualValue.startsWith(expectedValue);
            break;
          case "not-endsWith":
            conditionMet = !actualValue.endsWith(expectedValue);
            break;
          default:
            conditionMet = actualValue === expectedValue;
        }

        if (!conditionMet) return false;
      }
      return true;
    },
    [fieldValueMap]
  );
  const visibleFields = formSchema.filter(isFieldVisible); console.log("FORM SCHEMA", formSchema);
  console.log("FORM SCHEMA", formSchema);
console.log("VISIBLE FIELDS", visibleFields);
  return (
    <div className="juryentryboard_div">
      <JuryTitleBar
        logoImg={logoImg}
        eventName={eventName}
        fName={fName}
        lName={lName}
      />

      <div className="juryentryboard_white_bg">
        <div className="juryentryboard_head">
          <RedMainHeading>
            Judging - Submission <span style={{ color: "#777777" }}>Score</span>
          </RedMainHeading>
          <div className="juryentryboard_icon_head" onClick={() => navigate(-1)}>
            <MdOutlineKeyboardArrowLeft />
            <Description>Back to Entry Listing</Description>
          </div>
        </div>

        <div className="juryentryboard_main">
          {/* Submission Details Section */}
          <div className="juryentryboard_main_sub">
            <span className="juryentryboard_score_div">
              Submission #{submission_id}
            </span>

            {visibleFields.map((field, index) => {
              const dataName = field.dataName;
              const fieldValue = fieldValueMap[dataName] || "N/A";

              const mediaFile =
                normalJudgeData?.media_files?.find(
                  (file) => file.field_name === dataName
                );

              return (
                <div
                  className={`juryentryboard_head_content ${index % 2 === 0 ? "bg_grey" : ""
                    }`}
                  key={dataName}
                >
                  <SubGreyHeading>
                    {field.label}
                  </SubGreyHeading>

                  <StatusSubContent>
                    {field.type === "file" ? (
                      mediaFile ? (
                        <span
                          onClick={() => handleViewMedia(mediaFile)}
                          style={{
                            color: "blue",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          View File
                        </span>
                      ) : (
                        "No File"
                      )
                    ) : (
                      fieldValue
                    )}
                  </StatusSubContent>
                </div>
              );
            })}
          </div>

          {/* Scoring Section */}
          <div className="juryentryboard_main_sub_two">
            <RedMainHeading>Judging Criteria</RedMainHeading>
            <hr />

            {judgingData.map(entry => {
              const formSchema = typeof entry.form_schema === "string"
                ? JSON.parse(entry.form_schema)
                : entry.form_schema || [];

              return (
                <div className="juryentryboard_max_min" key={entry.scoreFormId}>
                  {formSchema.map((schema, schemaIndex) => (
                    <div key={schemaIndex}>
                      {schema.fields.map((field, fieldIndex) => {
                        const scoreKey = `${entry.scoreFormId}-${field.dataName}`;
                        const currentScore = selectedScores[scoreKey] || 0;

                        return (
                          <div
                            className="juryentryboard_sub_max_min"
                            key={`${schemaIndex}-${fieldIndex}`}
                          >
                            {field.label === "Title" && (
                              <>
                                <div className="juryentryboard_max_min_head">
                                  <SubGreyHeading>{String(field.value)}</SubGreyHeading>
                                  <RedContent>
                                    (Min: {field.minValue || 0}, Max: {field.maxValue || 10})
                                  </RedContent>
                                </div>

                                {normalJudgeData.is_abstain === 0 && (
                                  normalJudgeData.is_scoring_dropdown ? (
                                    <SelectBgWhiteBorder
                                      value={currentScore}
                                      onChange={e => handleScoreChange(
                                        entry.scoreFormId,
                                        field.dataName,
                                        e.target.value
                                      )}
                                    >
                                      {Array.from(
                                        { length: field.maxValue - field.minValue + 1 },
                                        (_, i) => i + Number(field.minValue)
                                      ).map(value => (
                                        <option key={value} value={value}>
                                          {value}
                                        </option>
                                      ))}
                                    </SelectBgWhiteBorder>
                                  ) : (
                                    <InputType
                                      type="number"
                                      min={field.minValue}
                                      max={field.maxValue}
                                      value={currentScore}
                                      onChange={e => handleScoreChange(
                                        entry.scoreFormId,
                                        field.dataName,
                                        e.target.value
                                      )}
                                    />
                                  )
                                )}
                              </>
                            )}

                            {field.label === "Description" && (
                              <StatusSubContent>
                                {String(field.value) || "No description provided"}
                              </StatusSubContent>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  ))}
                  <hr />
                </div>
              );
            })}

            {/* Total Score */}
            {normalJudgeData.is_total === 1 && (
              <div className="juryentryboard_max_min">
                <div className="juryentryboard_sub_max_min">
                  <div className="juryentryboard_max_min_head">
                    <SubGreyHeading>Total Score:</SubGreyHeading>
                    <RedMainHeading>
                      {calculateTotalScore()} / {calculateMaxScore()}
                    </RedMainHeading>
                  </div>
                  <div className="formula-display">
                    {judgingData.map(scorecard => (
                      <div key={scorecard.scoreFormId}>
                        <small>{scorecard.category}: {scorecard.overall_score}</small>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Comments Section */}
            {normalJudgeData.is_comments_box_judging === 1 && (
              <div className="juryentryboard_comment_box">
                <SubGreyHeading>Comments:</SubGreyHeading>
                <InputTextarea
                  value={comments}
                  onChange={e => setComments(e.target.value)}
                  placeholder="Provide feedback..."
                />
              </div>
            )}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="juryentryboard_actions">
          <GreyBackgroundButton
            style={{ width: "fit-content", padding: "0.8rem 2rem", marginLeft: "1rem" }}
            onClick={() => navigate(`/jury-entry-listing?${new URLSearchParams(queryParams).toString()}`, {
              state: {
                logoImg,
                eventName,
                fName,
                lName,
                awardCat,
                eventId,
                juryData,
                queryParams,
                eventIdd,
                awardCatId,
                judgeId,
              }
            })}
          >
            Back to Entry Listing
          </GreyBackgroundButton>
          <RedBackgroundButton onClick={handleSubmit}>
            Update Score
          </RedBackgroundButton>
        </div>
      </div>
      {showMediaModal && selectedMedia && (
  <div
  style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.8)",
    zIndex: 99999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  }}
>
    {selectedMedia.mime_type?.startsWith("image") && (
      <img
        src={selectedMedia.file_url}
        alt="Preview"
        style={{ maxWidth: "90%", maxHeight: "90%" }}
      />
    )}

    {selectedMedia.mime_type?.startsWith("video") && (
      <video controls src={selectedMedia.file_url} />
    )}

    <button onClick={() => setShowMediaModal(false)}>
      Close
    </button>
  </div>
)}
    </div>
  );

};